<template>
<div>
  <v-card class="ma-5 pa-2 font-weight-light ">
    <div md6 style="overflow: auto; height: 100%" class="local-table">
      <v-data-table
        dense
        ref="retroactiveResult"
        v-if="poiEnters && poiEnters.length"
        class="text-caption elevation-1"
        :headers="headers"
        :items="poiEnters"
        item-key="timestamp"
        style="height: 25vh"
        :multi-sort="true"
        :custom-sort="customSort"
      ></v-data-table>
    </div>
      <v-row class="pl-8 pt-1">
          <v-btn color="success" small @click="exportAsCsv" class="mr-2 font-weight-light">CSV</v-btn>
          <v-btn color="success" small @click="exportAsExcel" class="mr-2 font-weight-light">Excel</v-btn>
          <v-btn color="success" small @click="exportAsPdf" class="mr-2 font-weight-light">PDF</v-btn>
      </v-row>
  </v-card>
</div>
</template>

<script>
import translate from '@/utils/genTable/multilanguageHelper.js'
import dataTableSort from '@/utils/dataTableSort.js'
import Papa from 'papaparse'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
const Excel = require('exceljs')
export default {
  props: {
    poiEnters: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      headersToSkipInCsv: [
        'enteredAtLatitude',
        'enteredAtLongitude',
        'leftAtLatitude',
        'leftAtLongitude'
      ],
      headers: [
        {
          text: translate('Poi Name', 'retroactivePoiTable'),
          value: 'poiName',
          sortable: true
        },
        {
          text: translate('Vehicle', 'retroactivePoiTable'),
          value: 'vehicleLabel',
          sortable: true
        },
        {
          text: translate('Driver Entered Poi', 'retroactivePoiTable'),
          value: 'driverEnteredPoi',
          sortable: true
        },
        {
          text: translate('Driver Left Poi', 'retroactivePoiTable'),
          value: 'driverLeftPoi',
          sortable: true
        },
        {
          text: translate('Poi Entered At', 'retroactivePoiTable'),
          value: 'poiEnteredAt',
          sortable: true
        },
        {
          text: translate('Poi Left At', 'retroactivePoiTable'),
          value: 'poiLeftAt',
          sortable: true
        },
        {
          text: translate('Stay Time', 'retroactivePoiTable'),
          value: 'duration',
          sortable: true
        }
      ],
      sorts: {
        poiEnteredAt: 'date',
        poiLeftAt: 'date',
        duration: 'timespan'
      }
    }
  },
  methods: {
    prepareDataForExport() {
      let preparedData = []
      let tempObject = {}
      this.poiEnters.forEach(x => {
        tempObject = {}
        for (var prop in x) {
          var foundHeader = this.headers.find(h => {
            return h.value == prop
          })
          if (foundHeader) {
            var translatedProp = foundHeader.text
            tempObject[translatedProp] = x[prop]
          }
        }
        preparedData.push(tempObject)
      })

      return preparedData
    },
    exportAsCsv() {
      let preparedData = this.prepareDataForExport()

      var blob = new Blob(['\ufeff', Papa.unparse(preparedData)], {
        type: 'text/csv;charset=utf-8;'
      })

      var link = document.createElement('a')

      var url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute(
        'download',
        `Report-${Math.floor(Date.now() / 1000)}.csv`
      )
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    prepareHeadersForExcel() {
      let headers = []

      this.headers.forEach(header => {
        headers.push({
          name: header.text,
          filterButton: false
        })
      })

      return headers
    },
    prepareDataForExcel() {
      let data = []
      this.poiEnters.forEach(x => {
        let keys = Object.keys(x)

        // invert poiLeftAt and poiEnteredAt position
        let poiLeftAt = keys[4]
        keys[4] = keys[5]
        keys[5] = poiLeftAt

        let tempArray = []
        for (let key of keys) {
          if (this.headersToSkipInCsv.filter(y => y == key).length > 0) {
            continue
          }
          if (key == 'formated') {
            continue
          }
          if (x[key] == null) {
            x[key] = ''
          }
          tempArray.push(x[key])
        }
        data.push(tempArray)
      })

      data.forEach(x => {
        x.forEach(val => {
          if (typeof val == 'object') {
            let index = x.indexOf(val)
            if (index > -1) {
              x.splice(index, 1)
            }
          }
        })
      })

      return data
    },
    exportAsExcel() {
      const workbook = new Excel.Workbook()
      workbook.creator = 'Puregreen'
      workbook.lastModifiedBy = 'Puregreen'

      const ws = workbook.addWorksheet('Retroactive POI result')

      const headers = this.prepareHeadersForExcel()
      const data = this.prepareDataForExcel()

      ws.mergeCells('A1:E1')
      ws.getCell('A1').value = `${'Retroactive POI result'}`

      console.log(data)
      console.log(headers)

      ws.addTable({
        name: 'MyTable',
        ref: 'A3',
        headerRow: true,
        totalsRow: false,
        style: {
          theme: 'TableStyleLight20',
          showRowStripes: true
        },
        columns: headers,
        rows: data
      })

      const cellsToSkip = ['A1', 'B1', 'C1', 'D1', 'E1']

      ws.columns.forEach(column => {
        var dataMax = 0
        column.eachCell({ includeEmpty: true }, function(cell) {
          if (!cellsToSkip.includes(cell.address)) {
            var columnLength = cell.value ? cell.value.length : 0
            if (columnLength > dataMax) {
              dataMax = columnLength
            }
          }
        })
        column.width = dataMax < 10 ? 10 : dataMax + 5
      })

      workbook.xlsx.writeBuffer().then(function(data) {
        const blob = new Blob([data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = window.URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = `Report-${Math.floor(Date.now() / 1000)}.xlsx`
        anchor.click()
        window.URL.revokeObjectURL(url)
      })
    },
    exportAsPdf() {
      var source = this.$refs.retroactiveResult
      let headers = []
      let rows = []
      let pdfName = `Report-${Math.floor(Date.now() / 1000)}`

      this.headers.forEach(header => {
        headers.push({
          content: header.text,
          styles: { minCellWidth: 15, fontSize: 6 }
        })
      })

      headers.forEach(h => {
        h.content = h.content.replace('č', 'c')
        h.content = h.content.replace('Č', 'č')
        h.content = h.content.replace('đ', 'dj')
        h.content = h.content.replace('Đ', 'Dj')
      })

      source.items.forEach(element => {
        var temp = []
        for (var prop in element) {
          temp.push({
            content: element[prop] == null ? '' : element[prop],
            styles: { minCellWidth: 15, fontSize: 6 }
          })
        }

        rows.push(temp)
      })
      var doc = new jsPDF('landscape')
      doc.autoTable({
        head: [headers],
        body: rows,
        startY: 10
      })
      doc.save(pdfName + '.pdf')
    }
  },
  mounted() {
    dataTableSort.setSorts(this.sorts)
  },
  computed: {
    customSort: () => dataTableSort.sort
  }
}
</script>
